import React from "react";
import { InjectedFormProps, reduxForm, formValueSelector } from "redux-form";
import { Grid, Button } from "material-ui";
import ExtendedField from "components/form/ExtendedField";
import renderTextfield from "components/form/RenderTextField";
import { ReduxState, ReduxDispatch } from "../../../ducks/reducers";
import { connect } from "react-redux";
import validate from "./ProfileFormValidator";
import { PostalCodeDto } from "util/DTOs/PostalCodeDto";
import { getPostalCodes } from "ducks/postalcodes";

export interface EditProfileData {
    phoneNumber: string | null | undefined;
    email: string | null | undefined;
    streetAddress: string | null | undefined;
    postalCode: string | null | undefined;
}

export interface IEditProfileFormProps {
    form: string;
    onSubmit: (data: any) => void;
}

interface IEditProfileFormReduxProps {
    initialValues: any;
    postalCodes: PostalCodeDto[];
}

interface IEditProfileFormDispatchProps {}

export type EditProfileFormProps = IEditProfileFormProps &
    IEditProfileFormReduxProps &
    IEditProfileFormDispatchProps &
    InjectedFormProps<EditProfileData, IEditProfileFormProps>;

export const editProfileFormName = "editprofileform";

const EditProfileForm: React.SFC<EditProfileFormProps> = (
    props: EditProfileFormProps
) => {
    return (
        <form onSubmit={props.handleSubmit}>
            <Grid container>
                <Grid item xs={12} className={"profile-text-field-label"}>
                    <ExtendedField
                        component={renderTextfield}
                        name="phoneNumber"
                        type="tel"
                        placeholder=""
                        adornment=""
                        label={"Puhelinnumero"}
                        required={false}
                        className={"profile-text-field"}
                    />
                </Grid>
                <Grid item xs={12} className={"profile-text-field-label"}>
                    <ExtendedField
                        component={renderTextfield}
                        name="email"
                        type="email"
                        placeholder=""
                        adornment=""
                        label={"Sähköposti"}
                        required={false}
                        className={"profile-text-field"}
                    />
                </Grid>
                <Grid item xs={12} className={"profile-text-field-label"}>
                    <ExtendedField
                        component={renderTextfield}
                        name="streetAddress"
                        type="text"
                        placeholder=""
                        adornment=""
                        label={"Osoite"}
                        required={false}
                        className={"profile-text-field"}
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={12} className={"profile-text-field-label"}>
                    <ExtendedField
                        component={renderTextfield}
                        name="postalCode"
                        type="text"
                        placeholder=""
                        adornment=""
                        label={"Postinumero"}
                        required={false}
                        className={"profile-text-field"}
                        disabled={true}
                    />
                    {/* <AutoCompletePostalCity
                        name={"postalCode"}
                        type={"text"}
                        label={"Postinumero"}
                        required={false}
                        {...props}
                        className={"profile-text-field"}                       
                    /> */}
                </Grid>
                <Grid item xs={12} md={12}>
                    <Button
                        color="primary"
                        fullWidth={true}
                        variant="flat"
                        type={"submit"}
                        style={{ minHeight: "54px" }}
                        className={"profile-page-button"}
                        aria-label={"Tallenna"}
                    >
                        Tallenna
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

const form = reduxForm<EditProfileData, IEditProfileFormProps>({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(EditProfileForm);

const mapStateToProps = (state: ReduxState): IEditProfileFormReduxProps => {
    const postalCodes = getPostalCodes(state);

    return {
        initialValues: state.profile,
        postalCodes: postalCodes,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IEditProfileFormDispatchProps => {
    return {};
};

export default connect<
    IEditProfileFormReduxProps,
    IEditProfileFormDispatchProps,
    IEditProfileFormProps
>(
    mapStateToProps,
    mapDispatchToProps
)(form as any);



// WEBPACK FOOTER //
// ./src/views/profile/components/EditProfileForm.tsx